import {
  QuotationIndex,
  QuotationRequestStatus,
  QuotationStatus,
} from 'EstraSuppliers'

/* FILTERS */

export type FilterCompanyDictionary = {
  value: string | undefined
  label: string | undefined
}

export const filterCompanyDictionary = (
  allQuotations: QuotationIndex
): FilterCompanyDictionary[] => [
  { value: 'all', label: 'Tutte le aziende' },
  ...[...new Set(allQuotations.map(q => q.company_name))].map(dq => ({
    value: dq,
    label: dq,
  })),
]

export type QuotationStatusFilters = 'all' | 'new' | 'pending' | 'completed'

export type FilterStatusDictionary = Record<
  QuotationStatusFilters,
  {
    label: string
  }
>
export const filterStatusDictionary: FilterStatusDictionary = {
  all: {
    label: 'Tutti gli stati',
  },
  new: {
    label: 'Nuovi',
  },
  pending: {
    label: 'In elaborazione',
  },
  completed: {
    label: 'Completati',
  },
}

export const getActiveList = (
  data: QuotationIndex,
  activeStatusFilter: QuotationStatusFilters,
  activeCompanyFilter: string
): QuotationIndex => {
  const statusesForNew: QuotationRequestStatus[] = ['requested', 'rejected']
  const statusesForPending: QuotationRequestStatus[] = [
    'approved',
    'pending',
    'sent',
  ]
  const statusesForCompleted: QuotationStatus[] = ['rejected', 'completed']

  let filteredQuotations: QuotationIndex

  // Filter by status
  switch (activeStatusFilter) {
    case 'completed':
      filteredQuotations = data.filter(({ status, quotation_status }) => {
        console.log(status)
        console.log(quotation_status)
        return (
          quotation_status && statusesForCompleted.includes(quotation_status)
        )
      })
      break
    case 'pending':
      filteredQuotations = data.filter(
        ({ status, quotation_status }) =>
          !quotation_status && statusesForPending.includes(status)
      )
      break
    case 'new':
      filteredQuotations = data.filter(({ status }) =>
        statusesForNew.includes(status)
      )
      break
    default:
      filteredQuotations = data
      break
  }

  // Filter by company
  return filteredQuotations.filter(
    fq =>
      activeCompanyFilter === 'all' || fq.company_name === activeCompanyFilter
  )
}
